import styled from "styled-components";
import {Search24Hour} from "../autocomplete/Search24Hour";
import {SearchMinute} from "../autocomplete/SearchMinute";

interface Props {
    time: {
        hour: string;
        minute: string;
    };
    editTime: (hour: string, minute: string) => void;
    disabled?: boolean;
}

export const RoutingServiceTime2: React.FC<Props> = (
    {
        time,
        editTime,
        disabled,
    }
) => {
    return (
        <Container>
            <HourContainer>
                <Search24Hour
                    hour={time.hour}
                    setHour={(newHour) => {
                        editTime(newHour, time.minute);
                    }}
                    disabled={disabled}
                />
                <TimeContainerLabel>시</TimeContainerLabel>
            </HourContainer>
            <Width12/>
            <MinuteContainer>
                <SearchMinute
                    minute={time.minute}
                    setMinute={(newMinute) => {
                        editTime(time.hour, newMinute);
                    }}
                    disabled={disabled}
                />
                <TimeContainerLabel>분</TimeContainerLabel>
            </MinuteContainer>
        </Container>
    );
};

const Container = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HourContainer = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
`;

const MinuteContainer = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
`;

const TimeContainerLabel = styled.div`
  width: 14px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 13px 0 11px 0;
`;

const Width12 = styled.div`
  margin: 0 6px;
  padding: 0;
`;
